<template>
  <div class="bg" v-show="show">
    <div class="wrapper">
      <div class="headline">
        <p>请选择文稿类型</p>
        <img src="@assets/img/interview/close.svg" alt="close" class="close" @click="cancel()">
      </div>
      <div class="types">
        <div :class="{'type': true, 'active': type.code == t.code}" v-for="(t, i) in types" :key="i" @click="selectType(t)" v-show="t.title">
          <img class="selector" :src="type.code == t.code ? selectIcons.active : selectIcons.normal" alt="icon">
          <div class="con">
            <img :class="{picWidth: t.code==3}" :src="t.code == type.code ? t.icons.active : t.icons.normal" alt="icon">
            <p>{{t.title}}</p>
          </div>
        </div>
      </div>
      <div class="btns">
        <p class="confirm green" @click="confirm()">下一步</p>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'

export default {
  name: 'confirm',
  data() {
    return {
      show: false,
      selectIcons:{
        normal: require('@assets/img/common/selectIcon.svg'),
        active: require('@assets/img/common/selectIconOn.svg')
      },
      types: [
        {
          icons:{
            normal: require('@assets/img/common/sportIcon.svg'),
            active: require('@assets/img/common/sportIconOn.svg')
          },
          code: 4,
          title: '',
        },
        {
          icons:{
            normal: require('@assets/img/common/projectIcon.png'),
            active: require('@assets/img/common/projectIconOn.png')
          },
          code: 3,
          title: '',
        },
        {
          icons:{
            normal: require('@assets/img/common/radioIcon.svg'),
            active: require('@assets/img/common/radioIconOn.svg')
          },
          code: 2,
          title: '',
        },
        {
          icons:{
            normal: require('@assets/img/common/tvIcon.svg'),
            active: require('@assets/img/common/tvIconOn.svg')
          },
          code: 1,
          title: ''
        },
        {
          icons:{
            normal: require('@assets/img/common/normalIcon.svg'),
            active: require('@assets/img/common/normalIconOn.svg')
          },
          code: 0,
          title: ''
        }
      ],
      type: {},
      toType: ''
    }
  },
  methods: {
    async open(r, t = 'report') {
      this.r = r
      this.toType = t
      const types = await this.getData()
      this.matchTypes(types)

      if(types.length == 1){
        this.r(`${this.type.code}`)
        this.close()
      }else{
        this.show = true
      }
      
    },
    matchTypes(types) {
      console.log(types)
      if(types.length > 0){
        types.forEach((i, d) => {
          i.code = i.id
          this.types.forEach(j => {
            if (j.code == i.id) {
              this.$set(j, 'title', i.title)
            }
          })

          if(i.selected){
            this.type = i
          }
        })
      }else{
        this.cancel();
        this.$toast('请联系后台管理员')
      }
    },
    selectType(t) {
      this.type = t
    },
    close() {
      this.show = false
    },
    confirm() {
      this.close()
      if(this.type.code!=undefined){
        setTimeout(() => {
          this.r(`${this.type.code}`)
        }, 50)
      }
    },
    cancel() {
      this.r(false)
      this.close()
    },
    getData() {
      const info = {
        to_type: this.toType
      }
      return common.myFetch(apis.Rpt_typelist, info)
      .then(r => {
        if (r) {
          return r.type
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1222;
  }
  .wrapper {
    min-height: 290px;
    min-width: 490px;
    padding: 20px 30px;
    background-color: @bg;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    z-index: 99998;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    .headline {
      display: flex;
      align-items: center;
      justify-content: space-between;
      p {
        font-size: 24px;
        color: @dark;
        font-weight: bold;
      }
      .close {
        // position: absolute;
        // right: 28px;
        // top: 18px;
        cursor: pointer;
      }
    }
    .types {
      display: flex;
      height: 130px;
      width: 100%;
      // padding: 0 50px;
      justify-content: space-around;
      .type {
        width: 130px;
        height: 130px;
        border: 1px solid #dcdcdc;
        border-radius: 4px;
        margin-right: 10px;

        &:nth-last-of-type(1) {
          margin-right: 0;
        }
        cursor: pointer;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 10px;
        .selector {
          width: 16px;
          height: 16px;
        }
        .con {
          width: 78px;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: @sub;
          img {
            margin-bottom: 12px;
          }
        }
      }
      .active {
        border-color: @green;
        .con {
          color: @green;
        }
      }
    }
    .btns {
      height: 40px;
      align-items: center;
      display: flex;
      justify-content: center;

      p {
        &:nth-last-of-type(1) {
          margin-right: 0px;
        }
      }
    }
    .confirm, .cancel {
      background-color: @bg;
      width: 120px;
      text-align: center;
      line-height: 40px;
      height: 40px;
      border-radius: 100px;
      border: 1px solid @green;
      color: @green;
      font-size: 14px;
      // box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
    .green {
      margin-right: 20px;
      color: #fff;
      background-color: @green;
    }
    .picWidth {
      width: 27px;
      height: 27px;
    }
  }
</style>
